import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <ContactSection />
        <MediaSection />
        <FAQSection />
        <UpdatesSection />
        <CardsSection />
        <FeaturesSection />
        <TopicsSection />
        <RankingSection />
        <AboutSection />
        <AppSection />
        <CommentsSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}